<template>
  <div class="card inset">
    <!-- Doelmeter introductie -->
    <template v-if="$parent.intakeAdmin.beleggen.brand === 'Doelbeleggen'">
      <h2 class="title">
        <awesomeIcon icon="fa-regular fa-circle-dot"/>
        Beleggen met een doel
      </h2>
      <p>
        Onze doelmeter® is uw virtuele vermogensbeheerder. Hij verstrekt advies en beheert uw
        beleggingsportefeuille. Daarom is het belangrijk om vooraf een duidelijk en haalbaar doel
        te stellen: hoeveel kapitaal wilt u opbouwen en hoeveel tijd heeft u daarvoor? Heeft u al
        een startkapitaal en/of wilt u periodiek geld inleggen?
      </p>
    </template>
    <!-- Verantwoordelijkheid introductie -->
    <h2 class="title">
      <awesomeIcon icon="clipboard-check"/>
      Onze verantwoordelijkheid
    </h2>
    <p>
      Als vermogensbeheerder hebben wij de verantwoordelijkheid om te beleggen volgens een
      beleggingsprofiel dat past bij u, uw beleggingsdoel en uw financiële situatie. Daarom
      vinden wij het belangrijk om relevante en accurate informatie van u te hebben, waarmee
      wij een goed en verantwoord beleggingsplan kunnen maken.
      <br /><br />
      Onderwerpen en vragen die u in de vragenlijst kunt verwachten:
      <ul class="list">
        <li>Uw ervaring met beleggen</li>
        <li>Uw kennis van beleggen</li>
        <li>Uw beleggingsdoel</li>
        <li>Hoe lang u geld kunt missen</li>
        <li>De stand van uw vermogen, schulden, inkomen en uitgaven</li>
        <li>
          Hoe u reageert wanneer uw beleggingen in waarde dalen en hoeveel risico u wilt nemen
        </li>
        <li>
          Duurzaamheidsvoorkeuren
        </li>
      </ul>
      Zodra wij alle informatie hebben, ontvangt u het beleggingsplan. Hierin vindt u informatie
      over uw risicoprofiel en een toelichting op de samenstelling van uw portefeuille.
      {{
        $parent.intakeAdmin.beleggen.brand === 'Doelbeleggen'
        ? `Vanaf de start informeert de Doelmeter® u over de voortgang van uw beleggingen.
          Dagelijks wordt de waarde van uw portefeuille bijgewerkt en als er tussentijds
          mogelijkheden zijn om de haalbaarheid te verhogen, dan zal de Doelmeter® u daarop
          attenderen.`
        : `Vanaf de start kunt u uw beleggingen online inzien en de waarde van uw portefeuille
          wordt dagelijks bijgewerkt.`
      }}
    </p>
    <!-- Onderdeel financieël systeem introductie -->
    <h2 class="title">
      <awesomeIcon icon="university"/>
      Onderdeel van het financiële systeem
    </h2>
    <p>
      Vermogensbeheer is een financiële dienstverlening. Vermogensbeheer maakt daarom onderdeel
      uit van het Nederlandse financiële systeem. Om te zorgen dat dat goed en veilig blijft
      werken, nemen wij onze verantwoordelijkheid. Dit wordt ook door de overheid van ons
      gevraagd. Zo moeten wij ons houden aan de  Wet ter voorkoming van witwassen en financieren
      van terrorisme (Wwft). We stellen u daarom een aantal extra vragen en verzoeken u om een
      kopie van uw identiteitsbewijs te uploaden.
    </p>
  </div>
</template>

<script>

export default {
  name: 'IntakeIntroductionPage',
  emits: ['update:model-value'],
  props: {
    modelValue: Object,
  },
  computed: {
    typeToGoal() {
      if (this.modelValue.goalData.type === 'studiekinderen') {
        return 'studie kinderen';
      }
      if (this.modelValue.goalData.type === 'groteaankoop') {
        return 'grote aankoop';
      }
      if (this.modelValue.goalData.type === 'gouden-handdruk-opbouwend') {
        return 'gouden handdruk (opbouwend)';
      }
      if (this.modelValue.goalData.type === 'gouden-handdruk-uitkerend') {
        return 'gouden handdruk (uitkerend)';
      }
      if (this.modelValue.goalData.type === 'netto-lijfrente-uitkerend') {
        return 'Netto leefrente (uitkerend)';
      }
      if (this.modelValue.goalData.type === 'netto-lijfrente-opbouwend') {
        return 'Netto leefrente (opbouwend)';
      }
      if (this.modelValue.goalData.type === 'pensioen' && this.modelValue.goalData.box === '1') {
        return 'pensioen (box 1)';
      }
      if (this.modelValue.goalData.type === 'levensonderhoud' && this.modelValue.goalData.box === '1') {
        return 'leefrente (box 1)';
      }
      return this.modelValue.goalData.type;
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.card {
  color: $color-background;
}
</style>
